import { importAll } from './helper.js';
export const API_URL = 'http://168.61.91.132/api';
export const MAKSUTURVA_URL = 'https://test1.maksuturva.fi';
export const Images = importAll(require.context('./images', false, /\.(png|jpe?g|svg)$/));
export const TestHetu = '160264-999N';
export const TestFailHetu = '111248-999C';
export const TestAccountNumber = 'FI27 1234 5612 3456 73';
export const DOMAIN = 'http://168.61.91.132';
export const WP_SUB_DIRECTORY = 'wp-site';
